import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLazyViewManufacturedDeviceListQuery } from "../../../redux/api/mod-bus/modBusAPI";
import { setIsUpdateCurrentManufacturedData } from "../../../redux/features/mob-bus/mob-bus-slice";
import { EManufacturedSmartDeviceType } from "../../../shared/oversight-core/enums/manufactured-smart-device-type";
import { IManufacturedDeviceView } from "../../../shared/oversight-core/interfaces/manufactured-device-view";
import AppButton from "../../../shared/oversight-core/ui-elements/buttons/app-button/app-button";
import SpinnerModal from "../../../shared/oversight-core/ui-elements/spinner/spinner";
import { showErrorMessage } from "../../../shared/oversight-core/utils/toast";
import AddManufacturedDeviceModal from "./components/add-manufactured-device-modal";
import ManufacturedDeviceCard from "./components/manufactured-device-card";
import styles from "./iot-devices.module.scss";

const IotDevices = () => {
  const [showAddDeviceModal, setShowAddDeviceModal] = useState(false);
  const [devices, setDevices] = useState<IManufacturedDeviceView[]>([]);
  const [updateCurrentState, setIsUpdateCurrentState] = useState(false);

  const dispatch = useDispatch();

  const [triggerViewManufacturedDeviceList, { isFetching }] =
    useLazyViewManufacturedDeviceListQuery();

  useEffect(() => {
    triggerViewManufacturedDeviceList({
      smartDeviceType: EManufacturedSmartDeviceType.MODBUS_READER,
    })
      .unwrap()
      .then((res) => {
        setDevices(res.devices);
      })
      .catch(() => {
        showErrorMessage("Loading devices unsuccessful");
      });
  }, [updateCurrentState, triggerViewManufacturedDeviceList]);

  return (
    <>
      <Row className="mb-4">
        <Col className="col-auto">
          <AppButton
            text="Add Device"
            size="medium"
            iconName="add"
            onClick={() => setShowAddDeviceModal(true)}
          />
        </Col>
      </Row>
      {isFetching ? (
        <SpinnerModal show={true} withOverlay={false} />
      ) : devices.length > 0 ? (
        <div className={styles["device-list-container"]}>
          <Row>
            {devices.map((device) => (
              <Col key={device.deviceId} className="col-12 mb-1">
                <ManufacturedDeviceCard device={device} />
              </Col>
            ))}
          </Row>
        </div>
      ) : (
        <div className="container-dash font-size-14 text-muted text-center py-4">
          There are no devices available.
        </div>
      )}
      <AddManufacturedDeviceModal
        show={showAddDeviceModal}
        onClose={() => setShowAddDeviceModal(false)}
        onCancel={() => setShowAddDeviceModal(false)}
        closeAddManufacturedDeviceModal={() => {
          setShowAddDeviceModal(false);
          setIsUpdateCurrentState((ps) => !ps);
          dispatch(
            setIsUpdateCurrentManufacturedData({ isUpdateCurrentData: true }),
          );
        }}
      />
    </>
  );
};

export default IotDevices;
